import Game from '../../../Game';
import GameObject from '../../../GameObject/GameObject';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import { CardTypeMap } from '../../../Prototype/Level/Card/CardData';
import CardStateHelper from '../../../State/Card/CardStateHelper';
import ITask from '../../../Utility/Task/ITask';
import CardSystem from '../CardSystem';
import CardStateSyncTask from './CardStateSyncTask';

export default class CreateNewCardsTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        const state = system.state.getState();

        // Get an array of all card gameobject IDs to compare with IDs in the new state.
        const gameObjectIDs = system.cards.map((card: BaseCard) => {
            return card.id;
        });

        Object.keys(state.levelState.cardsState.cards)
            .filter(cardID => gameObjectIDs.indexOf(cardID) === -1)
            .forEach(cardID => {
                const cardData = state.levelState.cardsState.cards[cardID];
                const cardStatus = CardStateHelper.getCardStatus(state, cardID);
                const newCard: BaseCard = GameObject.Instantiate(
                    CardTypeMap[cardData.type].prototype,
                    {
                        ...cardData,
                        currentStatus: cardStatus,
                        cardBackTexture: Game.state.getState().playerState
                            .backcard,
                    }
                );

                system.cards.push(newCard);

                newCard.on(GameObjectEvent.POINTER_DOWN, () => {
                    if (
                        !system.taskQueue.isRunning() ||
                        system.taskQueue.getCurrentTask() instanceof
                            CardStateSyncTask
                    ) {
                        system.playCard(cardData.id);
                    }
                });
            });
    }
}
